// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/chunks/" + "bsn-tooltip" + "." + chunkId + "." + "61b8b0d766f4d4f8cc99" + ".js";
};